// extracted by mini-css-extract-plugin
export default {"select":"KbE2WBUPSQfG8MHM88tW"};